import React from 'react';
import { useTheme } from '../context/ThemeContext';

/**
 * The whale mark, in the variant that matches the current theme.
 *
 * The 8-bit asset is a real 32px-wide image rather than the full-size one
 * filtered at render time — downscaling produces genuine pixel data, so it
 * stays crisp at any size instead of looking like a blurred photo.
 */
const WhaleLogo: React.FC<{ className?: string; alt?: string }> = ({
  className = '',
  alt = 'Litrlly',
}) => {
  const { isRetro } = useTheme();

  return (
    <img
      src={isRetro ? '/whale-logo-8bit.png' : '/whale-logo.png'}
      alt={alt}
      className={`object-contain ${className}`}
    />
  );
};

export default WhaleLogo;
